import { APPS } from "../environments/apps";
export var AppHelper = {
    getAppHashByAppName: function (appName) {
        var appHash = APPS[appName];
        if (!!appHash) {
            return APPS[appName];
        }
        else {
            throw new Error("A aplica\u00E7\u00E3o '".concat(appName, "' n\u00E3o existe na lista de aplicativos."));
        }
    },
    getAppByAppHash: function (hash) {
        return Object.values(APPS).find(function (app) { return app.chave_sistema === hash; });
    }
};
